import { ActionTracking } from '@/core/interfaces';
import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import {
  ActionTrackingPostBody,
  NavigationTrackingPostBody,
} from 'src/server/schemas/tracking';
import { AuthService } from './auth.service';
import * as _ from 'lodash-es';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  private previousUrl: string | null = '';
  private currentUrl: string | null = '';
  private actionTrackingData: ActionTracking[] = [];
  private subscription!: Subscription;

  constructor(
    private router: Router,
    private authService: AuthService,
    private httpService: HttpService,
  ) {}

  public trackNavigation() {
    if (this.subscription) return;

    this.subscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.previousUrl = this.currentUrl || 'initial access to dashboard'; // Store the previous URL
        this.currentUrl = event.urlAfterRedirects; // Update the current URL

        const navigationTrackingData: NavigationTrackingPostBody = {
          user_id: this.authService.getUserId()!,
          from: this.previousUrl,
          to: this.currentUrl!,
        };

        this.postTrackingData('navigation', navigationTrackingData);
      });
  }

  public trackActions() {
    const actionTrackingData = this.preparePostActionTrackingData();
    actionTrackingData.length &&
      this.postTrackingData('actions', actionTrackingData);
  }

  public addActionTrackingData(action: string, page: string) {
    this.actionTrackingData.push({ action, page });
  }

  private postTrackingData(
    apiPath: string,
    data: ActionTrackingPostBody[] | NavigationTrackingPostBody,
  ) {
    this.httpService.postWithAuthCheck(`/${apiPath}`, data).subscribe(() => {
      this.actionTrackingData = [];
    });
  }

  // Prepare the action tracking data to be sent to the server
  private preparePostActionTrackingData(): ActionTrackingPostBody[] {
    const groupedByActionAndPage = _.groupBy(
      this.actionTrackingData,
      (item) => {
        return `${item.action}_${item.page}`;
      },
    );

    const actionTrackingData: ActionTrackingPostBody[] = [];

    Object.entries(groupedByActionAndPage).forEach(([key, value]) => {
      const [action, page] = key.split('_');

      actionTrackingData.push({
        user_id: this.authService.getUserId()!,
        action,
        page,
        count: value.length,
      });
    });

    return actionTrackingData;
  }
}
